/**
 * LEGACY - Chat service for Brief Coach mode
 * NOT USED in Brandmate Content Reviewer
 * Use sessionService.submitContent() instead
 */

// import apiClient from './api'

export const chatService = {
  /**
   * LEGACY - Get chat history for a session (Brief Coach mode)
   * NOT USED in Brandmate Content Reviewer
   *
   * @param {string} sessionId - The session ID to retrieve chat for
   * @returns {Promise<Object>} Chat data response
   */
  /*
  async getSessionChat(sessionId) {
    const response = await apiClient.get(`/sessions/${sessionId}/chat`)
    return response.data
  },
  */

  /**
   * LEGACY - Submit a message to a session (Brief Coach mode)
   * NOT USED in Brandmate Content Reviewer
   * Use sessionService.submitContent() instead
   *
   * @param {string} sessionId - The session ID to submit message to
   * @param {string} chatInput - The message content to submit
   * @returns {Promise<Object>} Submit message response
   */
  /*
  async submitMessage(sessionId, chatInput) {
    const response = await apiClient.post(`/sessions/${sessionId}/messages`, {
      chatInput
    })
    return response.data
  }
  */
} 